//import { Form, Link, useSearchParams, useActionData, useNavigation } from 'react-router-dom';
import { Form, useActionData, useNavigation } from 'react-router-dom';

import classes from './Authentication.module.css';

function Authentication() {
  const data = useActionData();
  const navigation = useNavigation();
  //const [ searchParams, setSearchParams ] = useSearchParams();
  const isLogin = true; // searchParams.get('mode') === 'login';
  const isSubmitting = navigation.state === 'submitting';

  //if (data) {
  //  console.log(`data: ${JSON.stringify(data)}`);
  //  console.log(`errors: ${data.errors}`);
  //} else {
  //  console.log('no data');
  //}

  //      <span><h1>{isLogin ? 'Log in' : 'Create a new user'}</h1></span> / <span>
  //          <Link to={`?mode=${isLogin ? 'signup' : 'login'}`}>
  //            {isLogin ? 'Create new user' : 'Login'}
  //          </Link>
  //      </span>
  return (
    <>
      <Form method="post" className={classes.form}>
        <div className={classes.actions}>
        </div>
        <p>
          <label htmlFor="email">Email</label>
          <input id="email" type="email" name="email" required />
        </p>
        <p>
          <label htmlFor="image">Password</label>
          <input id="password" type="password" name="password" required />
        </p>
        {!isLogin &&
          <p>
            <label htmlFor="image">Password Again</label>
            <input id="passwordagain" type="password" name="passwordagain" required />
          </p>
        }
        <div className={classes.actions}>
          {isLogin ?
            <button disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Login'}
            </button>
          :
            <button disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Create'}
            </button>
          }
        </div>
        {data && data.errors && (
          <ul>
            {Object.values(data.errors).map((error) => (
              <li className={classes.error} key={error}>{error}</li>
            ))}
          </ul>
        )}
      </Form>
    </>
  );
}

export default Authentication;
